import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Styles from './index.module.css';

function OrangeButton({
  children,
  onClick,
  disabled,
}) {
  const buttonClass = disabled ? Styles.disableButton : Styles.undisabledButton;
  return (
    <button
      type="button"
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

OrangeButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

OrangeButton.defaultProps = {
  disabled: false,
  onClick: () => {},
  children: null,
};

export default memo(OrangeButton);
